import BigNumber from 'bignumber.js';
import multicall from '../blockchain/multicall';
import nativeTokenAbi from '../config/abis/nativeToken.json';
import { getAddress } from '../utils/commons';
import { getContract } from './commons';

export const fetchAntiBot = async () => {
  const nativeTokenAddress = getAddress(process.env.REACT_APP_NATIVE_TOKEN);

  const nativeTokenCalls = [
    {
      address: nativeTokenAddress,
      name: 'maxUserTransferAmountRate',
    },
    {
      address: nativeTokenAddress,
      name: 'blacklistLength',
    },
    {
      address: nativeTokenAddress,
      name: 'decimals',
    },
    {
      address: nativeTokenAddress,
      name: 'maxUserTransferAmount',
    },
  ];

  const nativeTokenResults = await multicall(nativeTokenAbi, nativeTokenCalls);

  const maxUserTransferAmountRate = new BigNumber(nativeTokenResults[0]);
  
  return {
    antiBotWorking: maxUserTransferAmountRate.lt(10000),
    maxUserTransferAmountRate: maxUserTransferAmountRate.toJSON(),
    maxUserTransferAmount: new BigNumber(nativeTokenResults[3]).toJSON(),
    blacklistLength: new BigNumber(nativeTokenResults[1]).toJSON(),
    decimals: nativeTokenResults[2][0],
    firstLoad: false,
  }
};

export const blackListCheck = async (address) => {
  const nativeTokenContract = getContract(process.env.REACT_APP_NATIVE_TOKEN, nativeTokenAbi);
  return await nativeTokenContract.blacklistCheck(address);
}
